import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import { LoginContainer } from './Common'
import CloseButton from '../Shared/CloseButton'
import { hideRegisteredForm } from '../../actions/ui_actions'
import { Store } from '../../reducers'
import { Action } from '../../actions/types'

type Props = {
  close: (email: string) => Action
  email: string
}

class RegisteredForm extends React.Component<Props> {
  render() {
    const { close, email } = this.props

    return (
      <LoginContainer>
        <div className="modal-inner">
          <h4>
            <div className="spacer" />
            <CloseButton
              white={true}
              style={{ float: 'right' }}
              onClick={() => close(email)}
            />
          </h4>
          <div className="content">
            <h2>
              THANK YOU<br />FOR SIGNING UP
            </h2>
            <p>
              Your password has been emailed to you.<br />
              You can now login with your username and password.
            </p>
            <form onSubmit={() => close(email)}>
              <input type="submit" name="submit" value="LOGIN NOW" />
            </form>
          </div>
        </div>
      </LoginContainer>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  email: state.ui.email
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  close: email => dispatch(hideRegisteredForm(email))
})

export default connect(mapStateToProps, mapDispatchToProps)(RegisteredForm)



// WEBPACK FOOTER //
// ./src/Components/LoginForm/Registered.tsx